import {
  Button,
  FormControl,
  Image,
  Input,
  Stack,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../content/Content";
import VideoCarousel from "./VideoCarrousel";
import '../liveCast.component.css'
const RecordedSessions = () => {
  return (
    <VStack
      w="100%"
      pb="40px"
      pt="30px"
      borderRadius="26px"
      bg={"rgba(255, 255, 255, 1)"}
      my="50px"
    >
      {/* desktop-version */}
      <Stack className="desktop-version" w="100%" h="100%">
        <Stack
          flexDir="row"
          alignItems={"center"}
          w="100%"
          justifyContent={"space-between"}
          px="25px"
        >
          <Button
            bg="rgba(96, 31, 235, 1)"
            boxShadow="0px 15px 17px 0px rgba(96, 31, 235, 0.17)"
            fontFamily="'Roboto', sans-serif"
            fontWeight="500"
            fontSize={"20px"}
            color="rgba(255, 255, 255, 1)"
            borderRadius="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            w="234px"
            h="55px"
            transition={"0.3s"}
          >
            Recorded Sessions
          </Button>
          <Button
            boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.08)"
            bg="rgba(255, 255, 255, 1)"
            fontFamily="'Roboto', sans-serif"
            fontWeight="500"
            fontSize={"20px"}
            color="rgba(0, 0, 0, 1)"
            p="10px 30px"
            borderRadius="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            transition={"0.3s"}
            w="234px"
            h="55px"
            _hover={{
              bg: "rgba(96, 31, 235, 1)",
              boxShadow: "0px 15px 17px 0px rgba(96, 31, 235, 0.17)",
              color: "rgba(255, 255, 255, 1)",
            }}
          >
            Market ideas
          </Button>
          <Button
            boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.08)"
            bg="rgba(255, 255, 255, 1)"
            fontFamily="'Roboto', sans-serif"
            fontWeight="500"
            fontSize={"20px"}
            color="rgba(0, 0, 0, 1)"
            p="10px 30px"
            borderRadius="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            transition={"0.3s"}
            w="234px"
            h="55px"
            _hover={{
              bg: "rgba(96, 31, 235, 1)",
              boxShadow: "0px 15px 17px 0px rgba(96, 31, 235, 0.17)",
              color: "rgba(255, 255, 255, 1)",
            }}
          >
            Favorite ideas
          </Button>
          <FormControl
            position={"relative"}
            display="inline-block"
            alignItems="center"
            margin="0 10px"
            width="auto"
          >
            <Input
              type="text"
              bg="transparent"
              border={"none"}
              borderRadius="10px"
              padding={"8px 40px"}
              placeholder="Search video"
              fontFamily="'Roboto', sans-serif"
              fontSize="20px"
              fontWeight="500"
              color="rgba(149, 151, 171, 1)"
              _placeholder={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: "20px",
                fontWeight: "500",
                color: "rgba(149, 151, 171, 1)",
              }}
              backgroundColor="rgba(255, 255, 255, 1)"
              w="194px"
              h="55px"
              _focus={{ outline: "0" }}
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.08)"
            />
            <Image
              src={Img.search}
              alt="search"
              position={"absolute"}
              right="14px"
              top="18px"
              cursor="pointer"
              height="19px"
              w="19px"
            />
          </FormControl>
        </Stack>
        <VideoCarousel />
      </Stack>
      {/*  mobile-version*/}
      <Stack className="mobile-version"  w="100%" h="100%">
        <Stack
          flexDir="row"
          alignItems={"center"}
          w="100%"
          justifyContent={"space-between"}
          px="25px"
        >
          <Button
            bg="rgba(96, 31, 235, 1)"
            boxShadow="0px 15px 17px 0px rgba(96, 31, 235, 0.17)"
            fontFamily="'Roboto', sans-serif"
            fontWeight="500"
            fontSize={"14px"}
            color="rgba(255, 255, 255, 1)"
            borderRadius="10px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            w="219px"
            h="55px"
            transition={"0.3s"}
          >
            Recorded Sessions
          </Button>
          <FormControl
            position={"relative"}
            display="inline-block"
            alignItems="center"
            margin="0 10px"
            width="auto"
          >
            <Input
              type="text"
              bg="transparent"
              border={"none"}
              borderRadius="10px"
              padding={"8px 40px"}
              placeholder="Search video"
              fontFamily="'Roboto', sans-serif"
              fontSize="20px"
              fontWeight="500"
              color="rgba(149, 151, 171, 1)"
              _placeholder={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: "20px",
                fontWeight: "500",
                color: "rgba(149, 151, 171, 1)",
              }}
              backgroundColor="rgba(255, 255, 255, 1)"
              w="100%"
              h="55px"
              _focus={{ outline: "0" }}
              boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.08)"
            />
            <Image
              src={Img.search}
              alt="search"
              position={"absolute"}
              right="14px"
              top="18px"
              cursor="pointer"
              height="19px"
              w="19px"
            />
          </FormControl>
        </Stack>
        <VideoCarousel />
      </Stack>
    </VStack>
  );
};

export default RecordedSessions;
